import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'firstName',
    title: 'User Name',
    show: true,
    width: 332,
    valuesExport: ['firstName', 'lastName', 'email']
  },
  {
    isSortable: true,
    field: 'role',
    title: 'Role',
    show: true,
    width: 112,
    valuesExport: ['role']
  },
  {
    isSortable: false,
    field: 'comment',
    title: 'Comment',
    show: true,
    width: 232,
    valuesExport: ['comment']
  },
  {
    isSortable: true,
    field: 'score',
    title: 'Score',
    fromToGroup: true,
    show: true,
    width: 80,
    valuesExport: ['score']
  },
  {
    isSortable: true,
    field: 'lastUpdatedAt',
    title: 'Updated At',
    show: true,
    width: 142,
    valuesExport: ['lastUpdatedAt']
  }
];

export const exportConfigNps = {
  exportUrl: '/customer/satisfaction/nps/export',
  exportName: 'nps',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  role: [],
  lastUpdatedAt: { startDate: null, endDate: null }
};

export const defaultNavigation = {
  fieldName: 'lastUpdatedAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  score: {
    from: '',
    to: ''
  }
};
